import Colors from '../../theme/Colors';

const styles = {
  root: {
    height: 56,
    width: '100%',
    backgroundColor: Colors.lightBackground,
    zIndex: 100
  }
}

export default styles;
